module.exports = __webpack_public_path__ + "img/banner.bd054bef.jpg";